export default __webpack_public_path__ + "static/media/logo.f07059ac.png";